import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import "./loader.css";

interface LoaderProps {
  msg: string;
  loaderClassName?: string;
}
const LoaderTrans: React.FC<LoaderProps> = ({ msg, loaderClassName }) => {
  return (
    <div className={`loader ${loaderClassName}`}>
      <FontAwesomeIcon icon={faSpinner} spin size="3x" className="mr-4" />
      {msg}
    </div>
  );
};

export default LoaderTrans;
